export default function ProjectsLoading() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="relative w-16 h-16">
        <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
        <div className="absolute top-0 left-0 w-full h-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
      </div>
      <p className="mt-4 text-lg font-medium text-gray-600">Loading projects...</p>
      <p className="text-sm text-gray-500">Please wait while we fetch your data</p>
    </div>
  )
}
